/**
 * 翻译钩子
 * 提供翻译功能的便捷访问
 *
 * 核心功能：
 * 1. 访问TranslationContext
 * 2. 提供类型安全的上下文访问
 * 3. 确保在Provider内部使用
 */
import { useContext } from 'react';
import { TranslationContext } from '../contexts/TranslationContext.js';
/**
 * 使用翻译钩子
 * 提供翻译上下文的便捷访问
 *
 * @returns 翻译上下文值，包含翻译方法和状态
 * @throws 如果在TranslationProvider之外使用，会抛出错误
 *
 * @example
 * ```tsx
 * const { translationState, handleTextSubmit, translateSelectedText } = useTranslation();
 *
 * // 翻译文本
 * const handleTranslate = async () => {
 *   const result = await handleTextSubmit(text, 'en', 'zh', 'deepseek-v3');
 * };
 * ```
 */
export function useTranslation() {
    const context = useContext(TranslationContext);
    if (context === undefined) {
        throw new Error('useTranslation must be used within a TranslationProvider');
    }
    return context;
}
/**
 * 默认导出钩子函数
 * 便于导入使用
 */
export default useTranslation;
//# sourceMappingURL=useTranslation.js.map